import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PreparationApiAdapter } from '../adapters/PreparationApiAdapter';
import { CreatePreparationParams, PreparationService } from '../services/PreparationService';

interface UseCreatePreparationOptions {
  onSuccess?: (data: { success: boolean; message?: string; preparationId?: number }) => void;
}

export const useCreatePreparation = (options?: UseCreatePreparationOptions) => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new PreparationApiAdapter(httpClient);
  const preparationService = new PreparationService(apiAdapter);

  const mutation = useMutation({
    mutationFn: (params: CreatePreparationParams) => preparationService.createPreparation(params),
    onSuccess: (data) => {
      console.log('✅ Preparación creada exitosamente:', data);

      // Invalidar la query real del listado para forzar refetch inmediato
      queryClient.invalidateQueries({ queryKey: ['pendingOrders'] });

      // Llamar callback personalizado si se proporciona
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      console.error('❌ Error al crear preparación:', error);
    },
  });

  return {
    ...mutation,
    // Estados adicionales útiles
    isCreatingPreparation: mutation.isPending,
    isPreparationSuccess: mutation.isSuccess,
    preparationError: mutation.error,
  };
};
